import { OBTENER_COLA, OBTENER_AREAS, SESION_AREA, VALIDAR_AREA, AGENTE_LOGOUT, ACTUALIZAR_LISTA, VALIDAR_AGENTE, SESION_AGENTE, VALIDAR_USUARIO, SELECCIONAR_ROL, TRAER_SERVICIOS } from "../constants/action-types"
const initialState = {
  turnoRecibido: {
    identificacionUsuario: "",
    nombreUsuario: "",
    programaUsuario: "",
    semestreActualUsuario: "",
    facultadUsuario: "",
    horaSolicitud: "",
    generoUsuario: "",
    horaAtencion: ""
  },
  usuarioBase: {
    //identificacionUsuario:"",
    //nombreUsuario:"",
    //genero
    //correo
    //telefono
    //roles{
    //  rol
    //  programa
    //  codigo
    //  semestre
    //}

  },
  rol: {
    //  rol
    //  programa
    //  codigo
    //  semestre
  },
  servicios: [],
  agente: {
    //nombreAgente:""
    //apellidoAgente:""
    //correoAgente:""
    //identificacionAgente:""
    //areaAgente:""
    //mapaServicios:""
  },
  area: {
    //idArea
    //nombreArea
  },
  areas: [],
  respuestaArea: {
    //tipo:"",
    //mensaje:"",
  },
  respuestaLogin: {
    //tipo:"",
    //mensaje:"",
  },
  listaServicios: [],
  colaPantalla: []
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case VALIDAR_AREA:
      return { ...state, respuestaArea: action.payload };
    case SESION_AREA:
      return { ...state, area: action.payload };
    case OBTENER_AREAS:
      return { ...state, areas: action.payload };
    case VALIDAR_USUARIO:
      return { ...state, usuarioBase: action.payload };
    case SELECCIONAR_ROL:
      return { ...state, rol: action.payload };
    case TRAER_SERVICIOS:
      return { ...state, servicios: action.payload };
    case VALIDAR_AGENTE:
      return { ...state, respuestaLogin: action.payload };
    case SESION_AGENTE:
      return { ...state, agente: action.payload };
    case ACTUALIZAR_LISTA:
      return { ...state, listaServicios: action.payload };
    case AGENTE_LOGOUT:
      return { ...state, agente: action.payload };
    case OBTENER_COLA:
      return { ...state, colaPantalla: action.payload };
    default:
      return state;
  }
};
export default rootReducer;